// First-touch acquisition attribution (web).
// Captures the referrer + UTM params on the very first visit and locks them,
// so we can attribute a later registration to where the user came from.
const KEY = "wa_attribution_v1";

export function captureAttribution() {
  try {
    if (localStorage.getItem(KEY)) return; // first-touch only — never overwrite
    const params = new URLSearchParams(window.location.search);
    const data = {
      referrer: document.referrer || "",
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      landing_path: window.location.pathname || "/",
      captured_at: new Date().toISOString(),
    };
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch (e) {
    // localStorage unavailable — attribution is best-effort, never block the app
  }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}
